import React from "react";

const STYLES = {
  critical: "sev-critical",
  high: "sev-high",
  medium: "sev-medium",
  low: "sev-low",
};

export default function SeverityBadge({ severity }) {
  const s = (severity || "low").toLowerCase();
  const cls = STYLES[s] || STYLES.low;
  return (
    <span
      data-testid={`severity-${s}`}
      className={`${cls} inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[11px] font-semibold uppercase tracking-[0.1em]`}
    >
      {s}
    </span>
  );
}
